module.exports = __webpack_public_path__ + "assets/img/booth-scan-btn.2fcd9638.png";